import { render } from "./ApiPage.vue?vue&type=template&id=4a917dfe&ts=true"
import script from "./ApiPage.vue?vue&type=script&lang=ts"
export * from "./ApiPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__